export default "__VITE_ASSET__3b95fe71__"